module.exports = __webpack_public_path__ + "static/media/mixcloud.68ef4053.svg";